<template>
  <v-card>
    <v-card-title class="align-start d-none d-md-flex">
      <span>
        {{ $t('pages.rides_overview') }}
      </span>
    </v-card-title>
    <v-card-text>
      <!--      <div class="row">-->
      <div class="tracking-div">
        <!--        <div class="col-md-4">-->
        <div class="tracking-rides">
          <!-- Vetem ne celular. Numri del mbi buton, qe te dihet sa udhetime
               ka pa pasur nevoje ta hapesh. -->
          <div
            v-if="$vuetify.breakpoint.smAndDown"
            class="rides-toggle"
            @click="udhetimetHapur = !udhetimetHapur"
          >
            <v-icon size="18" color="#F57C00" class="mr-2">mdi-bus-multiple</v-icon>
            <span class="rides-toggle__label">{{ $t('pages.rides_overview') }}</span>
            <span class="rides-toggle__count">{{ rides.length }}</span>
            <v-icon
              size="20"
              class="ml-2"
              :style="{
                transform: udhetimetHapur ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
              }"
            >mdi-chevron-down</v-icon>
          </div>

          <v-expand-transition>
            <div v-show="!$vuetify.breakpoint.smAndDown || udhetimetHapur">
          <v-autocomplete
            v-model="bus_id"
            :items="buses"
            item-text="name"
            item-value="id"
            clearable
            dense
            outlined
            :label="$t('pages.buses')"
          ></v-autocomplete>
          <div v-if="rides.length === 0" class="text-center py-5">
            <v-icon size="100" class="py-10">mdi-bus-alert</v-icon>
            <h3>{{ $t('pages.no_on_route_trips') }}</h3>
          </div>
          <div v-else style="max-height: 600px" class="scroll">
            <div
              class="ride-card mb-3"
              v-for="element in rides"
              :key="element.id"
            >
              <div class="ride-card-header">
                <div class="ride-card-icon ride-icon-orange">
                  <v-icon size="18" color="#F57C00">mdi-bus</v-icon>
                </div>
                <span class="ride-card-bus-name" v-if="element.bus">{{ element.bus.name }}</span>
                <span class="ride-card-bus-name" v-else>—</span>
                <v-btn
                  type="button"
                  small
                  depressed
                  color="error"
                  class="ml-auto"
                  v-if="!element.finished_at"
                  @click="stopRide(element)"
                  :loading="stopRideLoading === 'loading-' + element.id"
                >
                  {{ $t('actions.stop') }}
                </v-btn>
              </div>
              <div class="ride-card-row" v-if="element.driver">
                <div class="ride-card-icon ride-icon-blue">
                  <v-icon size="16" color="#1976D2">mdi-account-tie-hat</v-icon>
                </div>
                <span class="ride-card-text">{{ element.driver.name }}</span>
              </div>
              <div class="ride-card-row">
                <div class="ride-card-icon ride-icon-green">
                  <v-icon size="16" color="#388E3C">mdi-clock-start</v-icon>
                </div>
                <span class="ride-card-text ride-card-text--muted">
                  {{ element.started_at | moment('DD/MM/YYYY') }}
                  <strong>{{ element.started_at | moment('HH:mm') }}</strong>
                </span>
              </div>
              <div class="ride-card-row" v-if="element.finished_at">
                <div class="ride-card-icon ride-icon-teal">
                  <v-icon size="16" color="#00897B">mdi-clock-end</v-icon>
                </div>
                <span class="ride-card-text ride-card-text--muted">
                  {{ element.finished_at | moment('DD/MM/YYYY') }}
                  <strong>{{ element.finished_at | moment('HH:mm') }}</strong>
                </span>
              </div>
            </div>
          </div>
            </div>
          </v-expand-transition>
        </div>
        <!--        <div class="col-md-8">-->
        <div class="tracking-map">
          <div class="tile-selector">
            <button v-for="s in tileStyles" :key="s.key" class="tile-btn"
              :class="{ active: tileStyle === s.key }" @click="tileStyle = s.key">{{ s.label }}</button>
          </div>
          <l-map
            style="height: 350px; border-radius: 14px; overflow: hidden;"
            :zoom="zoom"
            :center="center"
            ref="mymap"
          >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-marker
              v-for="(location, index) in busesLocation"
              :key="location.ride.id"
              :lat-lng="ankora(location)"
              :ref="`location-${location.ride.id}`"
            >
              <l-icon
                :icon-size="busIconSize(busLabel(location))"
                :icon-anchor="busIconAnchor(busLabel(location))"
                :icon-url="busIcon(location.ride && location.ride.bus_id, busLabel(location))"
              ></l-icon>
              <l-tooltip>
                {{ $t('pages.bus') }}:
                <span v-if="location.ride.bus">
                  {{ location.ride.bus.name }}
                </span>
                <br />
                {{ $t('pages.driver') }}:
                <span v-if="location.ride.bus">
                  {{ location.ride.driver.name }}
                </span>
                <br />
                {{ $t('pages.started_at') }}:
                <span v-if="location.ride.started_at">
                  {{ location.ride.started_at | moment('DD/MM/YYYY HH:mm') }}
                </span>
                <span v-else>-</span>
                <br />
                {{ $t('pages.finished_at') }}:
                <span v-if="location.ride.finished_at">
                  {{ location.ride.finished_at | moment('DD/MM/YYYY HH:mm') }}
                </span>
                <span v-else>-</span>
              </l-tooltip>
            </l-marker>
          </l-map>
        </div>
      </div>
    </v-card-text>

    <v-dialog v-model="studentsDialog" max-width="480" scrollable z-index="2000">
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between pa-4" style="border-bottom:1px solid rgba(0,0,0,0.12)">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-bus-side</v-icon>
            <span v-if="selectedRide">
              {{ selectedRide.bus ? selectedRide.bus.name : '-' }}
              <span class="text--secondary text-body-2 ml-2" v-if="selectedRide.driver">
                — {{ selectedRide.driver.name }}
              </span>
            </span>
          </div>
          <v-btn icon small @click="studentsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0" style="max-height:480px">
          <div v-if="studentsLoading" class="d-flex justify-center align-center py-10">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-else-if="!studentsLoading && rideStudents.taken.length === 0 && rideStudents.dropped.length === 0"
               class="text-center py-10 text--secondary">
            <v-icon size="48" class="mb-3 d-block">mdi-account-off-outline</v-icon>
            {{ $t('messages.no_students_taken_yet') }}
          </div>

          <div v-else>
            <div v-if="rideStudents.taken.length > 0">
              <div class="px-4 py-2" style="background:rgba(76,175,80,0.08)">
                <span class="text-caption font-weight-bold" style="color:#388E3C">
                  <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                  NË AUTOBUS ({{ rideStudents.taken.length }})
                </span>
              </div>
              <v-list dense class="py-0">
                <v-list-item v-for="student in rideStudents.taken" :key="'t-' + student.id" class="px-4">
                  <v-list-item-avatar size="32" class="mr-3">
                    <v-img v-if="student.avatar" :src="student.avatar"></v-img>
                    <v-icon v-else>mdi-account-circle</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium">{{ student.name }}</v-list-item-title>
                    <v-list-item-subtitle class="text-caption" v-if="student.taken_at">
                      Marrë: {{ student.taken_at | moment('HH:mm') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-chip x-small color="success" text-color="white">{{ $t('table.on_bus') }}</v-chip>
                </v-list-item>
              </v-list>
            </div>

            <v-divider v-if="rideStudents.taken.length > 0 && rideStudents.dropped.length > 0"></v-divider>

            <div v-if="rideStudents.dropped.length > 0">
              <div class="px-4 py-2" style="background:rgba(33,150,243,0.08)">
                <span class="text-caption font-weight-bold" style="color:#1976D2">
                  <v-icon small color="primary" class="mr-1">mdi-home-circle</v-icon>
                  ZBRITUR ({{ rideStudents.dropped.length }})
                </span>
              </div>
              <v-list dense class="py-0">
                <v-list-item v-for="student in rideStudents.dropped" :key="'d-' + student.id" class="px-4">
                  <v-list-item-avatar size="32" class="mr-3">
                    <v-img v-if="student.avatar" :src="student.avatar"></v-img>
                    <v-icon v-else>mdi-account-circle</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium">{{ student.name }}</v-list-item-title>
                    <v-list-item-subtitle class="text-caption" v-if="student.dropped_at">
                      Zbritur: {{ student.dropped_at | moment('HH:mm') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-chip x-small color="primary" text-color="white">Zbritur</v-chip>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="pa-3" style="border-top:1px solid rgba(0,0,0,0.12)">
          <span class="text-caption text--secondary">
            {{ $t('table.total_students', { count: rideStudents.total }) }}
          </span>
          <v-spacer></v-spacer>
          <v-btn small text color="primary" @click="openRideStudents(selectedRide)" :disabled="studentsLoading">
            <v-icon small class="mr-1">mdi-refresh</v-icon>{{ $t('actions.refresh') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import GoogleMapLoader from '../../components/GoogleMapLoader.vue';
import VueElementLoading from 'vue-element-loading';
// Levizja e autobusit midis dy pozicioneve, qe te mos kerceje.
import { glideTo } from '@/utils/marker-glide';
import { busIcon, busIconSize, busIconAnchor } from '@/utils/bus-icon';
import { Keys } from '/src/config.js';

export default {
  components: {
    GoogleMapLoader,
    VueElementLoading,
    Keys,
  },
  data() {
    return {
      isLoading: false,
      // E mbyllur ne nisje: ne celular harta duhet te jete gjeja e pare qe shihet.
      udhetimetHapur: false,
      tileStyle: ['satellite', 'standard', 'esri', 'terrain'].includes(localStorage.getItem('mapTileStyle'))
        ? localStorage.getItem('mapTileStyle')
        : 'satellite',
      tileStyles: [
        { key: 'satellite', label: 'Satelit' },
        { key: 'osm',       label: 'Standard' },
        { key: 'esri',      label: 'Esri' },
        { key: 'topo',      label: 'Terrain' },
      ],
      attribution:
        // '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        '',
      zoom: 11,
      center: [42.6526173, 21.1464795],
      markerLatLng: [42.6526173, 21.1464795],
      buses: [],
      bus_id: null,
      rides: [],
      busesLocation: [],
      hasFitBounds: false,
      pollInterval: null,
      stopRideLoading: null,
      studentsDialog: false,
      studentsLoading: false,
      selectedRide: null,
      rideStudents: { taken: [], dropped: [], total: 0 },
    };
  },
  mounted() {
    // Ankorat e markuesve. Jashte `data` qe te mos jene reaktive.
    this.ankorat = {};

    this.getAllBuses();
    this.getAllRides();
    this.getLocations();
    // Rifreskimi: nje udhetim mund te ndalet nga shoferi ose vetvetiu nga
    // sistemi, pa e ditur kjo faqe. Pa kete, shenja e autobusit mbetej ne
    // harte aty ku u ndal, derisa ringarkohej faqja.
    // (Me pare therritej `getRideBuses()`, qe nuk ekziston ketu.)
    this.pollInterval = setInterval(() => this.getAllRides(this.bus_id, true), 15000);
    const map = this.$refs.mymap.mapObject;
    map.addControl(new window.L.Control.Fullscreen());
    map.removeControl(map.attributionControl);
  },
  computed: {
    url() {
      const tiles = {
        osm:       'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        esri:      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        topo:      'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
      };
      return tiles[this.tileStyle] || tiles.satellite;
    },
  },
  methods: {
    /**
     * Pozicioni me te cilin lidhet shablloni — i pandryshueshem.
     *
     * Kthen gjithmone te njejtin varg per nje udhetim, ndaj vue2-leaflet nuk
     * e prek me markuesin pas krijimit dhe levizjen e zoteron `glideTo`.
     * Dyqani mbahet jashte `data`: po te ishte reaktiv, do te shkaktonte
     * riperpunim ne cdo kornize te animacionit.
     */
    ankora(location) {
      // Shablloni renderohet para `mounted`, ndaj dyqani krijohet ketu nese
      // ende nuk ekziston.
      if (!this.ankorat) this.ankorat = {};

      const id = location && location.ride ? location.ride.id : undefined;
      if (id === undefined) return location ? location.coordinates : undefined;

      if (!this.ankorat[id]) this.ankorat[id] = location.coordinates;
      return this.ankorat[id];
    },
    fitMapToBuses() {
      if (!this.busesLocation.length || this.hasFitBounds) return;
      this.hasFitBounds = true;
      const map = this.$refs.mymap?.mapObject;
      if (!map) return;
      const coords = this.busesLocation.map(l => l.coordinates);
      if (coords.length === 1) {
        map.setView(coords[0], 14);
      } else {
        map.fitBounds(coords, { padding: [50, 50], maxZoom: 14 });
      }
    },
    getAllBuses() {
      axios
        .get('/buses/list')
        .then((response) => {
          this.buses = response?.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error fetching buses',
            type: 'error',
          });
        });
    },
    /**
     * @param {number|null} bus_id   kufizimi ne nje autobus, kur eshte zgjedhur
     * @param {boolean} heshtur      pa mbulesen e ngarkimit, per rifreskimin periodik
     */
    getAllRides(bus_id, heshtur = false) {
      if (!heshtur) this.isLoading = true;
      axios
        .get('/rides', { params: { bus_id } })
        .then((response) => {
          this.rides = response?.data;
          // Nje autobus mund te kete disa udhetime brenda dites. Shenja vendoset
          // ne pozicionin e tanishem te autobusit, ndaj udhetimet e perfunduara
          // do te jepnin disa shenja identike, njera mbi tjetren. Ne harte dalin
          // vetem ato qe jane ende ne rruge; lista majtas i mban te gjitha.
          const neRruge = (this.rides || []).filter((r) => !r.finished_at);

          this.busesLocation = this.busesLocation.filter((l) => neRruge.some((r) => r.id === l.ride?.id));
          if (neRruge.length > 0) {
            neRruge.map((ride) => {
              const location = {
                ride,
                coordinates: [
                  ride?.bus?.latitude ?? 42.6664358,
                  ride?.bus?.longitude ?? 21.1175278,
                ],
              };

              const index = this.busesLocation.findIndex(
                (item) => item.ride?.id === location.ride?.id
              );

              if (index !== -1) {
                this.busesLocation[index] = location;
              } else {
                this.busesLocation.push(location);
              }

              this.busesLocation = this.busesLocation.map((l) => {
                const lat = Number(l.coordinates[0]);
                const lng = Number(l.coordinates[1]);

                if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                  console.warn('Invalid coords for', l.ride.id, l.coordinates);
                  return l;
                }

                return {
                  ...l,
                  coordinates: [lat, lng],
                };
              });

              this.$nextTick(() => {
                for (const l of this.busesLocation) {
                  const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
                  glideTo(cmp?.mapObject, l.coordinates);
                }
                this.fitMapToBuses();
              });
            });
          } else {
            this.busesLocation = [];
          }
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error fetching rides',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getLocations() {
      window.Echo.private(`bus-location`).listen('.location-updated', (e) => {
        // this.getAllRides(this.bus_id);

        if (!!this.bus_id && this.bus_id !== e.ride?.bus_id) {
          return;
        }

        const newRide = { ...e };
        newRide.coordinates = Object.values(newRide.coordinates);

        const index = this.busesLocation.findIndex(
          (item) => item.ride?.id === newRide.ride?.id
        );

        if (index !== -1) {
          this.busesLocation[index] = newRide;
        } else {
          return;
          this.busesLocation.push(newRide);
        }

        this.busesLocation = this.busesLocation.map((l) => {
          const lat = Number(l.coordinates[0]);
          const lng = Number(l.coordinates[1]);

          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            console.warn('Invalid coords for', l.ride.id, l.coordinates);
            return l;
          }

          return {
            ...l,
            coordinates: [lat, lng],
          };
        });

        this.$nextTick(() => {
          for (const l of this.busesLocation) {
            const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
            glideTo(cmp?.mapObject, l.coordinates);
          }
        });
      });
      window.Echo.private(`bus-location-refresh`).listen(
        '.location-refresh',
        (e) => {
          this.getAllRides(this.bus_id);
        }
      );
    },
    busIcon,
    busIconSize,
    busIconAnchor,

    /** Numri ose emri i shkurter i autobusit, i shfaqur nen shenje. */
    busLabel(location) {
      const emri = location && location.ride && location.ride.bus && location.ride.bus.name;
      if (!emri) return '';
      // Vetem numri kur emri eshte si "Autobusi 3"; perndryshe tre shkronjat e para.
      const numri = String(emri).match(/\d+/);
      return numri ? numri[0] : String(emri).slice(0, 3);
    },
    stopRide(ride) {
      this.stopRideLoading = 'loading-' + ride.id;
      axios
        .post(`/rides/${ride.id}/school-stop`)
        .then(() => {
          this.$notify({
            title: 'Success',
            text: 'Success stoping ride',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error stoping ride',
            type: 'error',
          });
        })
        .then(() => {
          this.stopRideLoading = null;
        });
    },
    openRideStudents(ride) {
      if (!ride) return;
      this.selectedRide = ride;
      this.studentsDialog = true;
      this.studentsLoading = true;
      this.rideStudents = { taken: [], dropped: [], total: 0 };
      axios
        .get(`/rides/${ride.id}/students-school`)
        .then((response) => {
          this.rideStudents = response.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Gabim gjatë ngarkimit të nxënësve',
            type: 'error',
          });
          this.studentsDialog = false;
        })
        .then(() => {
          this.studentsLoading = false;
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.pollInterval);
  },
  watch: {
    tileStyle(val) { localStorage.setItem('mapTileStyle', val); },
    bus_id: {
      handler: function (newVal) {
        this.getAllRides(newVal);
      },
      deep: true,
    },
    busesLocation: {
      handler() {
        this.$nextTick(() => {
          for (const l of this.busesLocation) {
            const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
            if (cmp?.mapObject) {
              cmp.mapObject.off('click');
              cmp.mapObject.on('click', () => this.openRideStudents(l.ride));
              const el = cmp.mapObject.getElement();
              if (el) el.style.cursor = 'pointer';
            }
          }
        });
      },
      deep: true,
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item i {
  cursor: pointer;
}

.v-application ul {
  padding-left: 12px !important;
}

.gm-style .gm-style-iw-d {
  color: #0d508b !important;
}
</style>

<style lang="scss">
.active-stop {
  background: rgba($primary-shade--light, 0.15) !important;
}

.scroll {
  overflow: scroll;
  scrollbar-gutter: stable;
}

.tracking-div {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.tile-selector {
  display: flex; gap: 6px; margin: 8px 0;
  overflow-x: auto; flex-wrap: nowrap; padding-bottom: 2px;
  -webkit-overflow-scrolling: touch; scrollbar-width: none;
}
.tile-selector::-webkit-scrollbar { display: none; }
.tile-btn {
  padding: 5px 14px; border-radius: 20px; font-size: 12px; font-weight: 600;
  border: 1.5px solid rgba(0,0,0,0.15); background: #fff; color: #475569;
  cursor: pointer; transition: all 0.15s; white-space: nowrap; flex-shrink: 0;
}
.tile-btn:hover { border-color: #F57C00; color: #F57C00; }
.tile-btn.active { background: #F57C00; color: #fff; border-color: #F57C00; }
.tracking-map {
  flex: 0 0 65%;
}

.tracking-rides {
  flex: 0 0 35%;
}

@media (max-width: 700px) {
  .tracking-div {
    flex-direction: column;
  }

  .tracking-map,
  .tracking-rides {
    flex: 0 0 100%;
  }
}

hr.divider {
  border-top: 1px solid #bbbb;
  border-radius: 25px;
  margin: 10px 7px;
  opacity: 0.5;
}

.tracking-map .leaflet-container { touch-action: none; z-index: 0; isolation: isolate; }
.leaflet-control-attribution { display: none !important; }

.ride-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,0.07);
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
}
.ride-card-header { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.ride-card-bus-name { font-weight: 700; font-size: 14px; }
.ride-card-row { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
.ride-card-icon {
  width: 30px; height: 30px; border-radius: 8px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
}
.ride-icon-orange { background: rgba(245,124,0,0.12); }
.ride-icon-blue   { background: rgba(25,118,210,0.12); }
.ride-icon-green  { background: rgba(56,142,60,0.12); }
.ride-icon-teal   { background: rgba(0,137,123,0.12); }
.ride-card-text { font-size: 13px; }
.ride-card-text--muted { color: #64748b; }

.rides-toggle {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 10px 14px;
  margin-bottom: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  cursor: pointer;
  user-select: none;
}

.rides-toggle__label {
  font-weight: 600;
  font-size: 0.95rem;
}

.rides-toggle__count {
  margin-left: 8px;
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 11px;
  background: #fff3e0;
  color: #e65100;
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
}
</style>